import { SaleFormInput } from '@src/core/buyerApiClient';
import { countFormInputs } from '@src/domains/orders/core/form-inputs/countFormInputs';
import { FormInputsState } from '@src/domains/orders/core/form-inputs/types';

export interface FormInputsCollection {
  inputs: Array<SaleFormInput[]>;
  state: FormInputsState;
}

/**
 * A collection is pending while it has inputs, has not completed, and some value is still missing.
 *
 * `null` and `''` both count as missing: letting an empty string through lets the buyer skip the
 * step and take a voucher without the required data.
 */
export const hasPendingFormInputs = (formInputs: FormInputsCollection | null | undefined): boolean =>
  formInputs != null &&
  countFormInputs(formInputs.inputs) > 0 &&
  formInputs.state !== FormInputsState.Completed &&
  formInputs.inputs.some((inputs) => inputs.some(({ value }) => value == null || value === ''));
